import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TaskProblem } from '@app/shared/interfaces';
import { BadgeComponent, IconComponent } from '@ui';

@Component({
  selector: 'sbnb-task-problems-viewer',
  standalone: true,
  imports: [CommonModule, IconComponent, BadgeComponent],
  templateUrl: './task-problems-viewer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskProblemsViewerComponent {
  readonly problems = input.required<TaskProblem[]>();
}
